import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}
import siteConfig from '../siteConfig.json'
const routes = [
	{
		path: '/',
		name: 'en-gb',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Download APK | GBWa Official Updated Version 2026`,
			keywords: 'GB WhatsApp download, GB WhatsApp APK, GB WhatsApp',
			description: `Download the GBWhatsApp apk official version (All versions, Old, New), We share weekly GBWhatsApp Pro feature updates and provide safe download links for your devices.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/`,
				},
			],
		},
		component: () => import('@/views/home.vue'),
	},
	{
		path: '/gbwhatsapp-banned-problem-fix/',
		name: 'gbwhatsapp-banned-problem-fix',
		meta: {
			appname: 'GBWhatsApp',
			title: `GBWhatsApp Banned Problem Fix – Reasons, Solutions, and Prevention Tips`,
			keywords: 'GBWhatsApp banned problem fix',
			description: `Explore GBWhatsApp banned problem fix, including reasons, solutions, chat backup tips, and prevention strategies to avoid temporary and permanent account bans.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gbappze.com/gbwhatsapp-banned-problem-fix/`,
				},
			],
		},
		component: () => import('@/views/blog-2.vue'),
	},
	{
		path: '/download/',
		name: 'download',
		meta: {
			appname: 'GBWhatsApp',
			title: `Download GB WhatsApp APK Latest Version 2026`,
			keywords: 'Download GB WhatsApp, Download GB WhatsApp APK',
			description: `Download GB WhatsApp APK latest version from our trusted source.With GB WhatsApp Download available for Android 5.0 and above, this verified 65 MB APK ensures a secure and seamless performance.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/download/`,
				},
			],
		},
		component: () => import('@/views/download.vue'),
	},
	{
		path: '/privacy-policy/',
		name: 'privacy-policy',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Privacy Policy',
			keywords: 'GBAppZe privacy, GBWhatsApp info, data protection',
			description: 'Read how GBAppZe respects your privacy and manages data responsibly when you visit our site or explore our GBWhatsApp-related content.',
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/privacy-policy/`,
				},
			],
		},
		component: () => import('@/views/privacy.vue'),
	},
	{
		path: '/disclaimer/',
		name: 'disclaimer',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Disclaimer',
			keywords: 'GBAppZe disclaimer, GBWhatsApp info disclaimer',
			description: 'Read the official disclaimer of GBAppZe regarding GBWhatsApp information, accuracy, and third-party content.',
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/disclaimer/`,
				},
			],
		},
		component: () => import('@/views/disclaimer.vue'),
	},
	{
		path: '/contact-us/',
		name: 'contact-us',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Contact Us',
			keywords: 'GBAppZe contact, GBWhatsApp help, support',
			description: 'Get in touch with GBAppZe for feedback, collaboration, or questions about our GBWhatsApp information and content.',
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/contact-us/`,
				},
			],
		},
		component: () => import('@/views/contact-us.vue'),
	},
	{
		path: '/blog/',
		name: 'blog',
		meta: {
			appname: 'GBWhatsApp',
			title: `Blog Collection — Guides, Tips and Tutorials`,
			keywords: 'blogs',
			description: `Browse all our blog posts about GB WhatsApp and related APK tutorials. Find helpful guides and step-by-step instructions.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gbappze.com/blog/`,
				},
			],
		},
		component: () => import('@/views/blogs.vue'),
	},
	{
		path: '/backup-gbwhatsapp-chats-to-google-drive/',
		name: 'backup-gbwhatsapp-chats-to-google-drive',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Backup GBWhatsApp Chats to Google Drive`,
			keywords: 'backup GBWhatsApp chats to google drive',
			description: `Guide to backing up GBWhatsApp chats to Google Drive. Covers setup, manual and automatic backups, storage management, and restoring data to keep your chats and media safe.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gbappze.com/backup-gbwhatsapp-chats-to-google-drive/`,
				},
			],
		},
		component: () => import('@/views/blog-1.vue'),
	},
	{
		path: '/gb-whatsapp-apk-for-pc-windows/',
		name: 'gb-whatsapp-apk-for-pc-windows',
		meta: {
			appname: 'GBWhatsApp',
			title: `Download GB WhatsApp APK for PC & Windows (2026 Latest Version)`,
			keywords: 'gb whatsapp for pc, gb whatsapp download for windows',
			description: `Download GB WhatsApp APK for PC & Windows with the latest 2026 version. Learn how to install GB WhatsApp on Windows 11/10 using an Android emulator. Also discover GB WhatsApp download options for Android and iOS users.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/gb-whatsapp-apk-for-pc-windows/`,
				},
			],
		},
		component: () => import('@/views/gb-whatsapp-pc-windows.vue'),
	},
	{
		path: '/gb-whatsapp-for-ios/',
		name: 'gb-whatsapp-for-ios',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Download for iOS & iPhone`,
			keywords: 'gb whatsapp ios, gb whatsapp iphone',
			description: `Download GB WhatsApp for iOS and iPhone with the latest 2026 guide. Learn about GB WhatsApp IPA installation methods, web access, risks, and safer alternatives for Apple users.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/gb-whatsapp-for-ios/`,
				},
			],
		},
		component: () => import('@/views/gb-whatsapp-ios.vue'),
	},
	{
		path: '/gb-whatsapp-old-versions/',
		name: 'gb-whatsapp-old-versions',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Old Version Download APK (All Versions 2015‒2026)`,
			keywords: 'gb whatsapp old version, gb whatsapp old version apk',
			description: `Download GB WhatsApp old version APK safely for Android devices. Explore all previous GB WhatsApp versions with direct download options, classic features, and compatibility for older phones.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/gb-whatsapp-old-versions/`,
				},
			],
		},
		component: () => import('@/views/gb-whatsapp-old-versions.vue'),
	},
	{
		path: '/how-to-reduce-gb-whatsapp-storage-usage/',
		name: 'how-to-reduce-gb-whatsapp-storage-usage',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Reduce GB WhatsApp Storage Usage (Clear Cache & Free Space 2026)`,
			keywords: 'gb whatsapp storage usage, reduce gb whatsapp storage',
			description: `Learn how to reduce GB WhatsApp storage usage on Android. Clear cache, manage media files, and free up space safely without losing important chats or data.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/how-to-reduce-gb-whatsapp-storage-usage/`,
				},
			],
		},
		component: () => import('@/views/blog-storage-usage.vue'),
	},
	{
		path: '/auto-reply-messages-for-small-business-owners-gbwhatsapp/',
		name: 'auto-reply-messages-for-small-business-owners-gbwhatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: `Best Auto Reply Messages for Small Business Owners on GB WhatsApp`,
			keywords: 'gb whatsapp auto reply, auto reply messages small business',
			description: `Looking for professional auto reply messages for GB WhatsApp? Discover ready-to-use templates for small businesses, online stores, service providers, and customer support.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/auto-reply-messages-for-small-business-owners-gbwhatsapp/`,
				},
			],
		},
		component: () => import('@/views/blog-auto-reply-small-business.vue'),
	},
	{
		path: '/gb-whatsapp-crashing-after-update/',
		name: 'gb-whatsapp-crashing-after-update',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Crashing After Update? 7 Fixes That Actually Work`,
			keywords: 'GB WhatsApp crashing after update',
			description: `Updated GB WhatsApp and now it keeps crashing? Discover the most common reasons behind the issue and 7 practical fixes that can help restore app stability quickly.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/gb-whatsapp-crashing-after-update/`,
				},
			],
		},
		component: () => import('@/views/blog-crashing-after-update.vue'),
	},
	{
		path: '/should-you-update-gbwhatsapp/',
		name: 'should-you-update-gbwhatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: `Should You Update GB WhatsApp? Pros, Cons & Risks Explained`,
			keywords: 'should you update gb whatsapp, gb whatsapp update risks',
			description: `Wondering whether to update GB WhatsApp? Learn the benefits, risks, new features, and why many experienced users wait before installing the latest version.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/should-you-update-gbwhatsapp/`,
				},
			],
		},
		component: () => import('@/views/blog-should-you-update.vue'),
	},
	{
		path: '/gb-whatsapp-vs-telegram/',
		name: 'gb-whatsapp-vs-telegram',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp vs Telegram: Full Comparison (Features, Privacy & Performance 2026)`,
			keywords: 'gb whatsapp vs telegram, telegram vs whatsapp',
			description: `Compare GB WhatsApp vs Telegram in detail. Learn differences in privacy, storage, customization, messaging features, and group functions to decide which app is better in 2026.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/gb-whatsapp-vs-telegram/`,
				},
			],
		},
		component: () => import('@/views/blog-vs-telegram.vue'),
	},
	{
		path: '/gbwhatsapp-vs-official-whatsapp-2026/',
		name: 'gbwhatsapp-vs-official-whatsapp-2026',
		meta: {
			appname: 'GBWhatsApp',
			title: `GBWhatsApp vs Official WhatsApp (2026): Features, Privacy & Why Users Switch`,
			keywords: 'GBWhatsApp 2026',
			description: `Compare GBWhatsApp vs Official WhatsApp in 2026. Learn why users choose GBWhatsApp for privacy, customization, and file sharing, plus risks, features, and safety tips.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gbappze.com/gbwhatsapp-vs-official-whatsapp-2026/`,
				},
			],
		},
		component: () => import('@/views/blog-gbwhatsapp-vs-official-whatsapp.vue'),
	},
]
const siteMapRoutes = routes.map((e) => ({
	path: e.path,
}))
console.log(siteMapRoutes)
export { siteMapRoutes }
export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
